export default __webpack_public_path__ + "static/media/agents_sacrificial_knife.3f044ce5.png";